import React, { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { styles } from './customer-idle-display-styles';
import ThemeLogo from 'src/common/components/theme-logo/theme-logo';
import TrainingModeWatermark from 'src/common/training-mode/training-mode-watermark';
import { useSelector } from 'react-redux';
import { AppState } from 'src/common/redux/configure-store';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from 'src/emerald-theme-provider';
import { StateConfig } from 'src/common/interfaces/dtos/ITouchpointTheme';
import CustomerCartLogo from 'src/common/components/cart-icon/customer-cart-image';

const CustomerIdleDisplay: React.FC = (): JSX.Element => {
  const { emeraldTheme } = useContext(ThemeContext);
  const noSaleStyles = emeraldTheme?.customerDisplay?.laneOpenNoSale;
  const noSaleProps: StateConfig = {
    backgroundColor: noSaleStyles?.backgroundColor,
    backgroundImageURL: noSaleStyles?.backgroundImageURL,
    bodyTextColor: noSaleStyles?.bodyTextColor,
    headingTextColor: noSaleStyles?.headingTextColor,
  };
  const classes = styles(noSaleProps);
  const trainingModeActive = useSelector((state: AppState): boolean => state.posMode.trainingMode);
  const { t } = useTranslation();

  const trainingModeWatermark = trainingModeActive ? (
    <TrainingModeWatermark supplementalStyles={classes.trainingWaterMark} />
  ) : null;

  return (
    <Grid
      container
      direction='row'
      className={clsx(
        'fullWidth',
        'fullHeight',
        trainingModeActive ? classes.trainingModeBackground : classes.themeBackground,
      )}
    >
      <Grid item xs={3} className={classes.trainingWatermarkContainer}>
        {trainingModeWatermark}
      </Grid>
      <Grid container item xs={6} data-testid='customer-display-idle' className={classes.grid}>
        <CustomerCartLogo styles={classes.customerCartLogo} />
        <Typography className={classes.text}>{t('NoSaleView_NewCustomer')}</Typography>
        <ThemeLogo styles={`${classes.logoContainer} ${classes.storeLogo}`} />
      </Grid>
      <Grid item xs={3} className={classes.trainingWatermarkContainer}>
        {trainingModeWatermark}
      </Grid>
    </Grid>
  );
};
export default CustomerIdleDisplay;
